import { render, staticRenderFns } from "./expressList.vue?vue&type=template&id=297c6a1a"
import script from "./expressList.vue?vue&type=script&lang=js"
export * from "./expressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports